import Loading from "../components/Loading";
import { useState, useEffect } from "react";
import axios from "axios";
function ReportView(props) {
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);

  useEffect(() => {
    if (report == null) {
      axios
        .get("api/reports/id/" + props.report)
        .then((response) => {
          const data = { ...response.data };

          console.log(data);
          setReport(data);
          setLoading(false);
          // console.log(markers);
        })
        // .then(() => {
        // setLoading(false);
        // console.log(markers);
        // })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [report]);

  function handleDownload() {
    const fileURL = window.URL.createObjectURL(
      new Blob(
        [
          JSON.stringify(report, null, 2)
            .replaceAll('"', "")
            .replaceAll("\\n", "\n\t\t")
            .replaceAll("\\t", "\t"),
        ],
        { type: "text/json" }
      )
    );

    let alink = document.createElement("a");
    alink.href = fileURL;
    alink.download = report.USER_CRASH_DATE + ".txt";
    alink.click();
  }

  return loading ? (
    <>
      <Loading />
    </>
  ) : (
    <div className="report-view">
      <div className="">
        <button className="download-button" onClick={handleDownload}>
          Download
        </button>
      </div>
      <div>
        <pre className="json-pretty">
          {JSON.stringify(report, null, 2)
            .replaceAll('"', "")
            .replaceAll("\\n", "\n\t\t")
            .replaceAll("\\t", "\t")}
        </pre>
      </div>
    </div>
  );
}
export default ReportView;
